module.exports = __webpack_public_path__ + "02_glasses_red.82566df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/02_glasses_red.png
// module id = YsJs
// module chunks = 0